import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import styled from "styled-components";
import { ReactSVG } from "react-svg";
import { timeStampToDateWithTime } from "../../../utils/formats";
import { parseDecisionType } from "../../../pages/ViewCreditProposal/detail/analisecredito/sections/OpinionsSection";

import Modal from "../../../components/Modal";
import FrontCredito from "../../../assets/navbar/Front_Credito_on_light_blue.svg";
import Input from "../../../pages/ViewCreditProposal/detail/Input";
import Button from "../../../components/Button-v2";

const ContraparteModal = (props) => {
  const { open, onClose, contraparte, onSave } = props;

  const [codigo, setCodigo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [status, setStatus] = useState(true);

  useEffect(() => {
    if (!contraparte) {
      setCodigo("");
      setDescricao("");
      setStatus(true);
    } else if (contraparte?.codigo) {
      setCodigo(contraparte?.codigo);
      setDescricao(contraparte?.descricao);
      setStatus(contraparte?.status);
    }
  }, [contraparte]);

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Header>
        <IconWrapper>
          <ReactSVG src={FrontCredito} />
        </IconWrapper>
        <TitleWrapper>
          <Title>Contraparte</Title>
        </TitleWrapper>
      </Header>
      <Body>
        <Card>
          <Grid container spacing={3}>
            <Grid item xs={12} md={2}>
              <Input disabled label="Código" value={codigo} />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Descrição"
                value={descricao}
                onChange={setDescricao}
                align="flex-start"
                disabled={codigo}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CustomCheckboxComponent
                checked={status}
                label="Ativo"
                onChange={(e) => setStatus(e.target.checked)}
              ></CustomCheckboxComponent>
            </Grid>

            <ButtonWrapper>
              <Button
                buttonTheme="goback"
                height="34px"
                width="150px"
                onClick={() => onSave({ codigo, descricao, status })}
              >
                Salvar
              </Button>
            </ButtonWrapper>
          </Grid>
        </Card>
      </Body>
    </Modal>
  );
};

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  display: none;
`;

const CustomCheckbox = styled.div`
  width: 28px;
  height: 28px;
  background-color: #f6f6f6;
  border: 2px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;

  ${HiddenCheckbox}:checked + & {
    border-color: #656565;
    background-color: #656565;
  }
`;

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding-top: 16px;
`;

const Checkmark = styled.span`
  visibility: hidden;
  color: white;
  font-size: 20px;
  ${HiddenCheckbox}:checked + ${CustomCheckbox} & {
    visibility: visible;
  }
`;

const CustomCheckboxComponent = ({ checked, onChange, label }) => {
  return (
    <CheckboxContainer>
      <HiddenCheckbox checked={checked} onChange={onChange} />
      <CustomCheckbox>
        <Checkmark>✔</Checkmark>
      </CustomCheckbox>
      <span style={{ marginLeft: "8px" }}>{label}</span>
    </CheckboxContainer>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;

  border-bottom: 3px solid #00a2e0;
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;

  svg {
    width: 50px;
    height: 50px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;

  margin: 0px 5px;
`;

const Title = styled.div`
  font-size: 18px;
  font-family: Roboto;
  font-weight: bold;
  line-height: 1.22;
  color: #383838;
`;

const Subtitle = styled.div`
  font-size: 15px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 1.2;
  color: #747576;
`;

const Body = styled.div`
  margin-top: 32px;
  width: 700px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;

  margin-top: 32px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${({ justify }) => justify || "flex-start"};
  align-items: ${({ align }) => align || "center"};
  font-size: ${({ fontSize }) => (fontSize != undefined ? fontSize : "12px")};
  font-family: Roboto;
  width: ${({ width }) => (width != undefined ? width : "100%")};
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  margin-top: ${({ marginTop }) => (marginTop != undefined ? marginTop : 0)}px;
  margin-bottom: ${({ marginBottom }) =>
    marginBottom != undefined ? marginBottom : 10}px;
  height: ${({ height }) => (height != undefined ? height : "auto")};
`;

export const Card = styled.div`
  padding: 21px 19px 26.4px 20px;
  border-radius: 6px;
  border: solid 1px #b9b9ba;
`;

export default ContraparteModal;
